import React from 'react'
import * as S from './style'
import { TypographyV2 as Typography } from '@taglivros/tag-components'
import Button from '../../components/Button/Button'
import { arrayOf, func, string } from 'prop-types'

const SubscriptionCard = ( {
  subscriptionIcon,
  featuredImage,
  mainTexts,
  supplementaryText,
  buttonLabel,
  buttonColor,
  buttonFontColor,
  buttonHandleOnClick,
  anchorText,
  anchorRef,
} ) => {
  return (
    <S.SubscriptionCard className="card">
      <S.BrandContainer>
        <img
          alt=""
          src={ subscriptionIcon }
          width="100%"
        />
      </S.BrandContainer>

      <S.FeaturedImageContainer>
        <img
          alt=""
          height="100%"
          src={ featuredImage }
        />
      </S.FeaturedImageContainer>

      <Typography
        as="span"
        color="TAG1-700"
        variant="text-small-regular"
      >
        {
          mainTexts.map( ( text, index ) => {
            if ( index ) {
              return (
                <>
                  <br />

                  <br />

                  { text }
                </>
              )
            }
            return text
          } )
        }
      </Typography>

      <Button
        color={ buttonColor }
        disabled={ false }
        onClick={ buttonHandleOnClick }
      >
        <Typography
          color={ buttonFontColor }
          variant="button-medium-bold"
        >
          { buttonLabel }
        </Typography>
      </Button>

      {
        supplementaryText ?
          <Typography
            as="span"
            color="TAG1-700"
            variant="text-small-regular"
          >
            { supplementaryText }
          </Typography> : null
      }

      {
        anchorText ?
          <a
            href={ anchorRef }
          >
            <Typography
              as="span"
              className="link"
              color="TAG1-700"
              variant="text-small-regular"
            >
              { anchorText }
            </Typography>
          </a>
          : null
      }

    </S.SubscriptionCard>
  )
}

SubscriptionCard.propTypes = {
  'anchorRef': string,
  'anchorText': string,
  'buttonColor': string.isRequired,
  'buttonFontColor': string,
  'buttonHandleOnClick': func,
  'buttonLabel': string.isRequired,
  'featuredImage': string.isRequired,
  'mainTexts': arrayOf( string ).isRequired,
  'subscriptionIcon': string.isRequired,
  'supplementaryText': string,
}

SubscriptionCard.defaultProps = {
  'anchorRef': '',
  'anchorText': null,
  'buttonFontColor': 'WHITE',
  'buttonHandleOnClick': () => {},
  'supplementaryText': null,
}

export default SubscriptionCard
